import React from 'react';
import { classes } from 'typestyle';
import {
    pageClassName,
    pageWithoutHeaderClassName,
    pageInnerClassName,
    pageInnerVcenteredClassName,
    pageBackgroundChildrenClassName,
    pageThemeBlueClassName,
    pageThemeGreenClassName
} from './page.style';
import { ThemeName } from '../../../types';

interface PageProps {
    children: React.ReactNode,
    vCentered?: boolean,
    withoutHeader?: boolean,
    backgroundChildren?: React.ReactNode,
    theme?: ThemeName
}

const Page: React.FC<PageProps> = ({
    children,
    vCentered = false,
    withoutHeader = false,
    backgroundChildren,
    theme = 'blue'
}) => (
    <div className={ classes(
        pageClassName,
        (() => {
            switch (theme) {
                case 'blue': return pageThemeBlueClassName;
                case 'green': return pageThemeGreenClassName;
            }
        })(),
        withoutHeader && pageWithoutHeaderClassName
    ) }>
        { backgroundChildren && (
            <div
                className={ pageBackgroundChildrenClassName }
                children={ backgroundChildren }/>
        ) }
        <div
            className={ classes(
                pageInnerClassName,
                vCentered && pageInnerVcenteredClassName
            ) }
            children={ children }/>
    </div>
);

export default Page;
